export default "__VITE_ASSET__Dj659Es1__"